import { useEffect, useState } from "react";
import { Label } from "@/components/ui/label";
import { hexToHsl, hslToHex } from "@/utils/color";

interface ColorFieldProps {
  label: string;
  description?: string;
  value: string;
  onChange: (hsl: string) => void;
}

export const ColorField = ({
  label,
  description,
  value,
  onChange,
}: ColorFieldProps) => {
  const incomingHex = hslToHex(value);
  const [localHex, setLocalHex] = useState(incomingHex);

  useEffect(() => {
    setLocalHex(incomingHex);
  }, [incomingHex]);

  const commit = () => {
    const hsl = hexToHsl(localHex);
    if (hsl !== value) onChange(hsl);
  };

  return (
    <div className="flex items-start gap-3 py-2">
      <input
        type="color"
        value={localHex}
        onChange={(e) => setLocalHex(e.target.value)}
        onBlur={commit}
        className="h-10 w-14 cursor-pointer rounded border border-border bg-transparent"
        aria-label={label}
      />
      <div className="flex-1">
        <Label className="text-sm font-medium">{label}</Label>
        {description ? (
          <p className="text-xs text-muted-foreground">{description}</p>
        ) : null}
        <p className="mt-1 font-mono text-xs text-muted-foreground">
          {localHex.toUpperCase()} · hsl({value})
        </p>
      </div>
    </div>
  );
};
